import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requireOnboarding = true }) {
  const { user, profile, loading, recoveryRequired } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-3" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 animate-spin text-rose" />
        <button
          onClick={() => window.location.reload()}
          className="text-xs text-cocoa/50 hover:text-rose mt-4 font-light"
        >
          Taking too long? Reload
        </button>
      </div>
    );
  }

  if (!user) {
    // Preserve the full intended destination (path + query) so logged-out
    // visitors following a shared deep link land on the content they wanted
    // after signing in / up.
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  // Recovery link was opened — force the user through the reset flow before
  // they can reach any protected content, even though a session exists.
  if (recoveryRequired) return <Navigate to="/reset-password" replace />;
  if (requireOnboarding && profile && !profile.onboarding_complete) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}
